import axios from 'axios';
import * as Sentry from "@sentry/react";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_API_URL, 
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`
  }
});


// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Sentry.captureException(error, {
      tags: {
        phase: 'request',
        section: 'axios-strapi',
      },
      extra: {
        message: error.message,
        config: error.config,
      },
    });
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    Sentry.captureException(error, {
      tags: {
        phase: 'response',
        section: 'axios-strapi',
      },
      extra: {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        responseData: error.response?.data,
      },
    });
    return Promise.reject(error);
  }
);

export default axiosInstance;